import Model from "flarum/Model";

export default class U2DiInfoDetails extends Model {}
Object.assign(U2DiInfoDetails.prototype, {
  id: Model.attribute("id"),
  base_id: Model.attribute("base_id"),
  zcxx: Model.attribute("zcxx"),
  ghtj: Model.attribute("ghtj"),
  jjxx: Model.attribute("jjxx"),
  lxxx: Model.attribute("lxxx"),
});